import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

import App from './App';
import BigDial from './Components/BigDial/BigDial';
import MontlyOutput from './Components/MonthlyOutput/MontlyOutput';

import ComparisonChart from './Components/ComparisonChart/ComparisonChart';

import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

//images
// import brightGlobe from './Media/BigDial/BigDial-BrightGlobe06.svg';

import PlantSources from './PlantSources/PlantSources'




//databases
// const jackson_2 = 'jackson2/'
// const paris = 'paris/'
const oldDb = ''


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

  <BrowserRouter>
    <Routes>
      <Route path="/" exact element={<App />}/>
      <Route path="big-dial" exact element={<BigDial brightGlobe={PlantSources[0].brightGlobe} 
              database={oldDb}/>}/>
      <Route path={`/${PlantSources[0].location}/${PlantSources[0].name.plantName}/big-dial` }
            exact element={<BigDial 
              brightGlobe={PlantSources[0].brightGlobe} 
              database={PlantSources[0].name.databaseName}
              displayName={PlantSources[0].name.displayName}
              location={PlantSources[0].displayLocation}
            />}/>
      <Route path={`/${PlantSources[1].location}/${PlantSources[1].name.plantName}/big-dial` }
            exact element={<BigDial 
              brightGlobe={PlantSources[1].brightGlobe} 
              database={PlantSources[1].name.databaseName}
              displayName={PlantSources[1].name.displayName}
              location={PlantSources[1].displayLocation}
            />}/>

      <Route path="monthly-output" exact element={<MontlyOutput database={oldDb}/>}/>
      <Route path={`/${PlantSources[0].location}/${PlantSources[0].name.plantName}/monthly-output`} 
            exact element={<MontlyOutput 
                database={PlantSources[0].name.databaseName}
                displayName={PlantSources[0].name.displayName}
              />}/>
      <Route path={`/${PlantSources[1].location}/${PlantSources[1].name.plantName}/monthly-output`} 
            exact element={<MontlyOutput 
                database={PlantSources[1].name.databaseName}
                displayName={PlantSources[1].name.displayName}
              />}/>
                
      
      <Route path="comparison-chart" exact element={<ComparisonChart />}/>
    </Routes>
  </BrowserRouter>

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
